import { computed, ComputedRef } from 'vue';
import { useQueryV2 } from '@libs/use';
import { StrategyLegs } from '@libs/api-reference';

import * as API from '../requests';
import { OPTION_QUERY_KEYS } from '../constants';

type TUseOptionStrategiesQuery = {
  isin: ComputedRef<string>;
  immediate?: ComputedRef<boolean> | boolean;
};

export default function useOptionStrategyLegsQuery({
  immediate,
  isin,
}: TUseOptionStrategiesQuery) {
  const {
    result,
    status: getOptionStrategyLegsStatus,
    execute: getOptionStrategyLegs,
    isPending: isLoadingOptionStrategyLegs,
    isSuccess: isSuccessLoadingOptionStrategyLegs,
    isError: isErrorLoadingOptionStrategyLegs,
  } = useQueryV2<StrategyLegs>(
    () =>
      API.getOptionStrategyLegs({
        pageNumber: 1,
        pageSize: 100,
        contractInfoId: isin.value,
      }),
    {
      key: OPTION_QUERY_KEYS.strategyLegs(isin.value),
      immediate,
    }
  );

  const optionStrategyLegs = computed(() => {
    return result.value?.data.items || [];
  });

  return {
    optionStrategyLegs,
    getOptionStrategyLegs,
    getOptionStrategyLegsStatus,
    isLoadingOptionStrategyLegs,
    isSuccessLoadingOptionStrategyLegs,
    isErrorLoadingOptionStrategyLegs,
  };
}
